import { Component } from '@angular/core';

export interface Taller {
  title: string;
  description: string;
  benefit: string;
  price: string;
  lugar: string;
  fecha: string;
  image: string;
}

@Component({
  selector: 'app-talleres',
  standalone: true,
  templateUrl: './talleres.html',
  styleUrl: './talleres.scss',
})
export class TalleresComponent {
  talleres: Taller[] = [
    {
      title: 'Taller crear desde la calma',
      description:
        'Un taller pensado para bajar el ritmo y dedicarte un rato para ti. A través de una dinámica creativa guiada, exploraremos la calma como punto de partida.',
      benefit: 'merienda y materiales incluidos',
      price: '15€',
      lugar: 'Espacio Aruma',
      fecha: 'Sábado 28 de Marzo | 18:00',
      image: 'images/taller-1.png',
    },
    {
      title: 'Taller explorar con color',
      description:
        'Una sesión de exploración libre con color y forma. No hacen falta conocimientos previos, solo ganas de jugar y descubrir qué quiere expresar tu parte más creativa.',
      benefit: 'merienda y materiales incluidos',
      price: '20€',
      lugar: 'Espacio Aruma',
      fecha: 'Sábado 12 de Abril | 18:00',
      image: 'images/taller-2.png',
    },
    {
      title: 'Taller volver a ti',
      description:
        'Un espacio de introspección creativa donde la creación es el pretexto para escucharte. Ideal si buscas un momento de pausa y reconexión personal.',
      benefit: 'merienda y materiales incluidos',
      price: '18€',
      lugar: 'Espacio Aruma',
      fecha: 'Sábado 26 de Abril | 18:00',
      image: 'images/taller-3.png',
    },
  ];

  openContacto() {
    const el = document.getElementById('contacto');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
